import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/esm/asyncToGenerator";
import { getTokenFromBody, getTokenUrl } from './utils';
export function init(config) {
  var url = getTokenUrl(config);
  return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var response, body, token;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetch(url, {
              method: 'GET',
              credentials: 'include'
            });

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.text();

          case 5:
            body = _context.sent;
            token = getTokenFromBody(body);

            if (token) {
              _context.next = 9;
              break;
            }

            throw new Error('[LivePerson] Failed to fetch token');

          case 9:
            return _context.abrupt("return", token);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9hdXRoL2luaXQudHMiXSwibmFtZXMiOlsiZ2V0VG9rZW5Gcm9tQm9keSIsImdldFRva2VuVXJsIiwiaW5pdCIsImNvbmZpZyIsInVybCIsImZldGNoIiwibWV0aG9kIiwiY3JlZGVudGlhbHMiLCJyZXNwb25zZSIsInRleHQiLCJib2R5IiwidG9rZW4iLCJFcnJvciJdLCJtYXBwaW5ncyI6Ijs7QUFBQSxTQUFTQSxnQkFBVCxFQUEyQkMsV0FBM0IsUUFBOEMsU0FBOUM7QUFXQSxPQUFPLFNBQVNDLElBQVQsQ0FBY0MsTUFBZCxFQUF1RDtBQUM1RCxNQUFNQyxHQUFHLEdBQUdILFdBQVcsQ0FBQ0UsTUFBRCxDQUF2QjtBQUVBLCtFQUFPO0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsbUJBQ2tCRSxLQUFLLENBQUNELEdBQUQsRUFBTTtBQUNoQ0UsY0FBQUEsTUFBTSxFQUFFLEtBRHdCO0FBRWhDQyxjQUFBQSxXQUFXLEVBQUU7QUFGbUIsYUFBTixDQUR2Qjs7QUFBQTtBQUNDQyxZQUFBQSxRQUREO0FBQUE7QUFBQSxtQkFLY0EsUUFBUSxDQUFDQyxJQUFULEVBTGQ7O0FBQUE7QUFLQ0MsWUFBQUEsSUFMRDtBQU1DQyxZQUFBQSxLQU5ELEdBTVNYLGdCQUFnQixDQUFDVSxJQUFELENBTnpCOztBQUFBLGdCQVFBQyxLQVJBO0FBQUE7QUFBQTtBQUFBOztBQUFBLGtCQVNHLElBQUlDLEtBQUosQ0FBVSxvQ0FBVixDQVRIOztBQUFBO0FBQUEsNkNBWUVELEtBWkY7O0FBQUE7QUFBQTtBQUFBO0FBQUE7QUFBQTtBQUFBO0FBQUEsR0FBUDtBQWNEIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgZ2V0VG9rZW5Gcm9tQm9keSwgZ2V0VG9rZW5VcmwgfSBmcm9tICcuL3V0aWxzJztcblxuZXhwb3J0IHR5cGUgVG9rZW4gPSBzdHJpbmc7XG5cbmV4cG9ydCB0eXBlIENBU0NvbmZpZyA9IHtcbiAgcmVzcG9uc2VUeXBlOiBzdHJpbmc7XG4gIHJlZGlyZWN0VXJsOiBzdHJpbmc7XG4gIGNhc1VybDogc3RyaW5nO1xuICBjbGllbnRJZDogc3RyaW5nO1xufTtcblxuZXhwb3J0IGZ1bmN0aW9uIGluaXQoY29uZmlnOiBDQVNDb25maWcpOiAoKSA9PiBQcm9taXNlPFRva2VuPiB7XG4gIGNvbnN0IHVybCA9IGdldFRva2VuVXJsKGNvbmZpZyk7XG5cbiAgcmV0dXJuIGFzeW5jICgpID0+IHtcbiAgICBjb25zdCByZXNwb25zZSA9IGF3YWl0IGZldGNoKHVybCwge1xuICAgICAgbWV0aG9kOiAnR0VUJyxcbiAgICAgIGNyZWRlbnRpYWxzOiAnaW5jbHVkZScsXG4gICAgfSk7XG4gICAgY29uc3QgYm9keSA9IGF3YWl0IHJlc3BvbnNlLnRleHQoKTtcbiAgICBjb25zdCB0b2tlbiA9IGdldFRva2VuRnJvbUJvZHkoYm9keSk7XG5cbiAgICBpZiAoIXRva2VuKSB7XG4gICAgICB0aHJvdyBuZXcgRXJyb3IoJ1tMaXZlUGVyc29uXSBGYWlsZWQgdG8gZmV0Y2ggdG9rZW4nKTtcbiAgICB9XG5cbiAgICByZXR1cm4gdG9rZW47XG4gIH07XG59XG4iXX0=